import React, { forwardRef,MouseEvent, MutableRefObject } from 'react';
import { InputBase } from 'component-library';
import { IInputProps } from 'component-library/atoms/InputBase/InputBase';
import { handleMaskingMouseDown } from '../../../../component-library/utils/utils';

const InputPhone = forwardRef(
	(
		{ className = '', value, advancedMasking, setValue, mask = '000-000-0000', maxLength = 10, ...rest }: IInputProps,
		ref: MutableRefObject<HTMLInputElement> | any,
	) => {
		const getRawVal = (phone) => {
			const rawVal = phone?.replace(/[^0-9]/g, '');
			return rawVal;
		};

		const isPhoneValid = (val) => {
			const cleanVal = getRawVal(val);
			return !(cleanVal.length >= 1 && cleanVal.length < maxLength);
		};

		return (
			<InputBase
				{...rest}
				type='tel'
				mask={advancedMasking ? '(000) 000-0000' : mask}
				maxLength={maxLength}
				className={`InputPhone ${className}`}
				isValid={isPhoneValid}
				value={value}
				ref={ref}
				setValue={(phone) => {
					setValue(phone);
				}}
				advancedMasking={advancedMasking}
				{...(advancedMasking && {
					blurPlaceholderChar: '_',
					lazy: false,
					onMouseDown: (e: MouseEvent<HTMLInputElement> ) => {
						e.preventDefault();
						e.currentTarget.focus()
					}	
				})}
			/>
		);
	},
);

InputPhone.displayName = 'InputPhone';

export default InputPhone;
